<template>
  <div id="track">
    <v-tabs v-model="tab" class="mb-5">
      <v-tabs-slider color="lime"></v-tabs-slider>

      <v-tab>Проверить груз</v-tab>
      <v-tab>Калькулятор</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card elevation="1">
          <v-card-title>Проверить местонахождение груза</v-card-title>
          <v-card-text>
            <v-form v-model="validTrack" @submit.prevent="onTrack">
              <v-text-field
                required
                filled
                label="Номер трек кода"
                v-model="track.trackNumber"
                hide-details
                class="mb-5"
                prepend-inner-icon="mdi-package"
              ></v-text-field>

              <div class="buttons d-flex">
                <v-btn depressed class="mr-5" color="primary" type="submit"
                  ><v-icon left>mdi-magnify</v-icon> Проверить</v-btn
                >
                <v-btn depressed color="primary" outlined @click="tab = 1"
                  ><v-icon left> mdi-calculator</v-icon> Калькулятор</v-btn
                >
              </div>
            </v-form>
            <!-- <div
              class="result"
              v-if="Object.values(resultTrackcode).length > 0"
            ></div> -->
            <div
              class="result mt-5 pa-5"
              v-if="
                Object.values(resultTrackcode).length > 0 &&
                resultTrackcode.status != 'error'
              "
            >
              <ul v-if="resultTrackcode != null">
                <li>
                  <span><v-icon left small>mdi-calendar</v-icon> Дата: </span>
                  <strong>{{ getTime(resultTrackcode.created_at) }}</strong>
                </li>
                <li>
                  <span
                    ><v-icon left small>mdi-truck-fast</v-icon> Транспорт:
                  </span>
                  <strong>{{ transportType(resultTrackcode.type) }}</strong>
                </li>
                <li>
                  <span
                    ><v-icon left small>mdi-map-marker</v-icon> Местонахождение:
                  </span>
                  <strong>{{
                    resultTrackcode.custom.length > 0
                      ? resultTrackcode.custom
                      : calcLocation(
                          resultTrackcode.created_at,
                          resultTrackcode.type
                        )
                  }}</strong>
                </li>
                <li>
                  <span
                    ><v-icon left small>mdi-information-outline</v-icon> Статус:
                  </span>
                  <strong>{{
                    resultTrackcode.status == "open" ? "Открытый" : "Закрытый"
                  }}</strong>
                </li>
              </ul>
            </div>

            <v-alert
              type="info"
              class="mt-5"
              v-if="resultTrackcode.status == 'error'"
            >
              Извините, такой трек код не существует.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card-title>Рассчитать примерную стоимость перевозки</v-card-title>
        <v-card-text>
          <v-form v-model="validCalc" @submit.prevent="onCalc">
            <div class="d-flex mb-5">
              <v-text-field
                required
                filled
                label="Вес груза в кг"
                v-model="calc.weight"
                hide-details
                class="mr-2"
                prepend-inner-icon="mdi-weight-kilogram"
              ></v-text-field>
              <v-text-field
                required
                filled
                label="Объем в м³"
                v-model="calc.volume"
                hide-details
                class="ml-2"
                prepend-inner-icon="mdi-package-variant-closed"
              ></v-text-field>
            </div>
            <v-select
              :items="items"
              required
              filled
              label="Спецефикация груза"
              hide-details
              return-object
              item-text="name"
              v-model="calc.specefic"
              prepend-inner-icon="mdi-menu"
              class="mb-5"
            ></v-select>

            <div class="buttons d-flex">
              <v-btn depressed class="mr-5" color="primary" type="submit"
                ><v-icon left>mdi-calculator</v-icon> Рассчитать</v-btn
              >
            </div>
          </v-form>
          <div class="result mt-5 pa-5" v-if="calc.result">
            <ul>
              <li>
                <span><v-icon left small>mdi-pan</v-icon> Плотность: </span>
                <strong>{{ calc.density }}кг/м³</strong>
              </li>
              <li>
                <span
                  ><v-icon left small>mdi-weight-kilogram</v-icon> Стоимость за
                  1кг:
                </span>
                <strong>${{ calc.perKG }}</strong>
              </li>

              <li>
                <span
                  ><v-icon left small>mdi-database</v-icon> Стоимость перевозки:
                </span>
                <strong>${{ calc.result }}</strong>
              </li>
            </ul>
          </div>

          <v-alert type="info" class="mt-5" v-if="calc.result == null">
            Извините, вес груза должен быть не менее 100кг.
          </v-alert>
        </v-card-text>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>


<script>
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

import "dayjs/locale/ru";
dayjs.locale("ru");

export default {
  name: "TrackCode",
  data: () => ({
    validTrack: false,
    validCalc: false,
    tab: null,
    track: {
      trackNumber: "",
    },
    calc: {
      waight: "",
      volume: "",
      specefic: "",
      perKG: "",
      result: "",
      density: "",
    },
    items: [
      {
        name: "Стеклянный",
        slug: "steklo",
        tariff: 0,
      },
      {
        name: "Металлисческий",
        slug: "metall",
        tariff: 0,
      },
      {
        name: "Особо хрупкий",
        slug: "hrupki",
        tariff: 0,
      },
      {
        name: "Пластиковый",
        slug: "plastic",
        tariff: 0,
      },
      {
        name: "Другое",
        slug: "drugoe",
        tariff: 0,
      },
    ],

    resultTrackcode: {},
  }),
  methods: {
    onTrack() {
      this.$axios
        .get(`${process.env.VUE_APP_REQURL}/truck/${this.track.trackNumber}`)
        .then((res) => {
          console.log(res);

          if (res.data == null) {
            this.resultTrackcode = {
              status: "error",
              msg: "Извините, такой трек код не существует.",
            };
          } else {
            this.resultTrackcode = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    transportType(number) {
      if (number == 0) {
        return "Авиа 7-10 дней";
      } else if (number == 1) {
        return "Авто 10-12 дней";
      } else if (number == 2) {
        return "Авто 15-18 дней";
      } else if (number == 3) {
        return "ЖД 18-25 дней";
      } else if (number == 4) {
        return "Море 25-30 дней";
      }
    },
    getTime(time) {
      return dayjs(time).format("DD/MM/YYYY");
    },
    calcLocation(time, number) {
      const publishDate = new Date(time);
      const currentDate = new Date();

      const resultDay = Math.ceil(
        Math.abs(currentDate.getTime() - publishDate.getTime()) /
          (1000 * 3600 * 24)
      );

      if (number == 0) {
        if (resultDay <= 4) {
          return "Груз направляется к китайской таможне";
        } else if (resultDay > 4) {
          return "Груз проходит процесс таможенной очистки";
        }
      } else if (number == 1) {
        if (resultDay <= 5) {
          return "Груз направляется к китайской таможне";
        } else if (resultDay > 5) {
          return "Груз проходит процесс таможенной очистки";
        }
      } else if (number == 2) {
        if (resultDay <= 5) {
          return "Груз направляется к китайской таможне";
        } else if (resultDay > 5) {
          return "Груз проходит процесс таможенной очистки";
        }
      } else if (number == 3) {
        if (resultDay <= 5) {
          return "Груз направляется к китайской таможне";
        } else if (resultDay > 5) {
          return "Груз проходит процесс таможенной очистки";
        }
      } else if (number == 4) {
        // Морская доставка
        if (resultDay <= 15) {
          return "Груз направляется к китайской таможне";
        } else if (resultDay > 15) {
          return "Груз проходит процесс таможенной очистки";
        }
      }
    },
    onCalc() {
      const wg = parseInt(this.calc.weight);
      const vl = parseFloat(this.calc.volume);

      if (wg > 100) {
        const res = Math.round(wg / vl);
        this.calc.density = res;

        let perKG;
        if (res > 100 && res <= 200) {
          perKG = parseFloat(2.7);
        } else if (res >= 201 && res <= 300) {
          perKG = parseFloat(2.1);
        }
        if (res >= 301 && res <= 400) {
          perKG = parseFloat(1.8);
        }
        if (res >= 401 && res <= 600) {
          perKG = parseFloat(1.3);
        }
        if (res >= 601 && res <= 1000) {
          perKG = parseFloat(0.9);
        }

        this.calc.perKG = perKG;

        const calcRes = wg * perKG;
        this.calc.result = calcRes;
      } else {
        this.calc.result = null;
      }
    },
  },
};
</script>